import React, { useState, useEffect, useContext } from "react";
import TablePostulates from "./tablePostulates";
import { useStateValue } from "../../context/store";
import { headers } from "./dataPostulates";
import ModalConfirm from "../../utils/form/modalConfirmBase";
import { getPostulatesStatus } from "../../actions/postulates-actions";
import { getFilterPostulates } from "../../actions/postulates-actions";
import { getProfessions } from "../../actions/profession-actions";
import PostulatesSearch from "./postulatesSearch";
import ModalVacancieUser from "./modalVacancieUser";
import { TablePagination, Typography } from "@material-ui/core";
import Search from "../../images/icons/search.svg";
import { styles } from "../styles";
import _ from "lodash";
import { useParams } from "react-router";
import { DataContext } from "../../context/reducers/contextSearchUser";

const Index = (props) => {
  const { idVacancie } = useParams();
  const { setIdVacancie } = useContext(DataContext);
  const classes = styles();
  const [open, setOpen] = useState(false);
  const [{ filterPostulate }, dispatch] = useStateValue();
  const [statusPostulates, setStatusPostulates] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const [data, setData] = useState({
    personName: null,
    provinceId: null,
    townId: null,
    levelEducation: null,
    status: null,
    professionId: null,
    yearsExperience: null,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const getReqs = async () => {
    const response = await getFilterPostulates(
      {
        personName: data.personName === "" ? null : data.personName,
        personSurname: data.personSurname === "" ? null : data.personSurname,
        provinceId: data.provinceId === "" ? null : data.provinceId,
        townId: data.townId === "" ? null : data.townId,
        levelEducation: data.levelEducation === "" ? null : data.levelEducation,
        status: data.status === "" ? null : data.status,
        professionId: data.professionId === "" ? null : data.professionId,
        yearsExperience:
          data.yearsExperience === "" ? null : data.yearsExperience,
        vacantId: idVacancie,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );
    if (response && (response.status === 200 || response.status === 201)) {
      const data = response?.data;
      if (data?.content.length > 0) {
        setPaginadorResponse({
          data: data?.content,
          totalRows: data?.totalElements,
          pageSize: data?.size,
          pageNumber: data?.page,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : response?.data?.error,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  useEffect(() => {
    setIdVacancie(idVacancie);
    getReqs();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Postulados",
      breadCrumbSubText: "Postulados",
      index: 51,
    });
    getAllPostulatesStatus();
  }, [paginadorRequest]);

  if (
    filterPostulate &&
    filterPostulate?.isFilter &&
    data !== filterPostulate.filter
  ) {
    const newfilter = filterPostulate.filter;
    data.personName = newfilter.personName;
    data.personSurname = newfilter.personSurname;
    data.provinceId = newfilter.provinceId;
    data.townId = newfilter.townId;
    data.levelEducation = newfilter.levelEducation;
    data.status = newfilter.status;
    data.professionId = newfilter.professionId;
    data.yearsExperience = newfilter.yearsExperience;
    paginadorRequest.page = 0;
    getReqs();
    dispatch({
      type: "SET_FILTER_POSTULATES",
      isFilter: false,
    });
  }

  const getAllPostulatesStatus = async () => {
    const result = await getPostulatesStatus();
    const newArray = [];
    const entries = Object.entries(result.data);
    for (let [key, value] of entries) {
      newArray.push({ key, value });
    }
    setStatusPostulates(newArray);
  };

  const getAllProfessions = async () => {
    const resp = await getProfessions();
    setProfessions(_.sortBy(resp?.data?.professionList));
  };

  useEffect(() => {
    getAllProfessions();
  }, []);

  const setOpenModal = () => setOpen(!open);

  return (
    <div>
      <PostulatesSearch
        statusPostulates={statusPostulates}
        professions={professions}
      />

      {paginadorResponse?.data?.map((row, index) => (
        <TablePostulates
          headers={headers}
          data={row}
          setOpen={setOpenModal}
          setMessage={setMessage}
          message={message}
          props={props}
          getReqs={getReqs}
        />
      ))}

      {paginadorResponse?.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          labelRowsPerPage="Registros por página"
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
        />
      ) : (
        <React.Fragment>
          <div className={classes.messageSearch}>
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado
            </Typography>
          </div>
        </React.Fragment>
      )}

      <ModalVacancieUser setOpen={setOpenModal} open={open} />

      <ModalConfirm
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        type={message.type}
        open={message.open}
      />
    </div>
  );
};

export default Index;
